import { createDraftSafeSelector } from '@reduxjs/toolkit';

import { getMergedMediaSupport } from 'modules/refData/utils';
import { MediaRulesByType } from 'modules/refData/types/RefData';

import type { RootState } from '../../App/rootReducer';

const getRefData = (state: RootState) => state.refData;

const getMediaRules = createDraftSafeSelector(
  getRefData,
  (refData) => refData?.media,
);

export const getAvailableThemes = createDraftSafeSelector(
  getRefData,
  (refData) => refData?.availableThemes,
);

const getChatMessageRawMediaRules = createDraftSafeSelector(
  getMediaRules,
  (mediaRules) => {
    const { image, video, document } = mediaRules?.message ?? {};
    return { image, video, document };
  },
);

const getMobilityDocumentRawMediaRules = createDraftSafeSelector(
  getMediaRules,
  (mediaRules) => mediaRules?.mobility?.document?.media,
);

const getVehicleCheckRawMediaRules = createDraftSafeSelector(
  getMediaRules,
  (mediaRules) => mediaRules?.['vehicle-check']?.item?.['response-media'],
);

const getRepairOrderRawMediaRules = createDraftSafeSelector(
  getMediaRules,
  (mediaRules) => ({
    image: mediaRules?.['self-service']?.image,
    video: mediaRules?.['self-service']?.video,
  }), // `mediaRules?.['self-service']?.document` refers to a repair order document instead of the `document` media rule.
);

export const getChatMessageFileLimit = createDraftSafeSelector(
  getChatMessageRawMediaRules,
  (mediaRules: MediaRulesByType) => (
    Math.min(mediaRules.document['max-files'], mediaRules.image['max-files'], mediaRules.video['max-files'])
  ),
);

export const getChatMessageMediaSupport = createDraftSafeSelector(getChatMessageRawMediaRules, getMergedMediaSupport);
export const getMobilityDocumentdMediaSupport = createDraftSafeSelector(getMobilityDocumentRawMediaRules, getMergedMediaSupport);
export const getVehicleCheckImageSupport = createDraftSafeSelector(
  getVehicleCheckRawMediaRules,
  ({ image }) => getMergedMediaSupport({ image }),
);
export const getVehicleCheckVideoSupport = createDraftSafeSelector(
  getVehicleCheckRawMediaRules,
  ({ video }) => getMergedMediaSupport({ video }),
);
export const getRepairOrderMediaSupport = createDraftSafeSelector(getRepairOrderRawMediaRules, getMergedMediaSupport);

export const getWorkflows = createDraftSafeSelector(getRefData, ({ workflows = {} }) => workflows);
